import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../core/Buttons';

import { StyledModal } from './style';
import {
  legalTextFirst,
  legalTextFourth,
  legalTextSecond,
  legalTextThird,
  legalTextFifth,
  legalExternalTextFirst,
  legalExternalTextSecond,
  legalExternalTextThird,
  legalExternalTextFourth,
  legalExternalTextFifth,
  legalTextExternalUsersTtile
} from './utils';

const ModalLegalWarning = ({
  typology,
  setaceptLegalConditions,
  onAceptLegal
}) => (
  <StyledModal title="CUMPLIMIENTO NORMATIVO Y PROTECCIÓN DE DATOS">
    <div className="legal-scroll">
      {typology === 'INTERNAL' && (
        <>
          <p className="legal-text">{legalTextFirst}</p>
          <p className="legal-text">{legalTextSecond}</p>
          <p className="legal-text">{legalTextThird}</p>
          <p className="legal-text">{legalTextFourth}</p>
          <p className="legal-text">{legalTextFifth}</p>
        </>
      )}
      {typology === 'EXTERNAL' && (
        <>
          <p className="legal-text">{legalExternalTextFirst}</p>
          <p className="legal-text">{legalExternalTextSecond}</p>
          <p className="legal-text">{legalExternalTextThird}</p>
          <p className="legal-text">{legalExternalTextFourth}</p>
          <p className="legal-text-external-title">
            {legalTextExternalUsersTtile}
          </p>
          <p className="legal-text">{legalExternalTextFifth}</p>
        </>
      )}
    </div>
    <div className="center">
      <Button
        className="legal-acept"
        dark
        onClick={() => {
          onAceptLegal();
          setaceptLegalConditions(true);
        }}
      >
        Aceptar
      </Button>
    </div>
  </StyledModal>
);

ModalLegalWarning.propTypes = {
  setaceptLegalConditions: PropTypes.func,
  onAceptLegal: PropTypes.func,
  typology: PropTypes.string
};

export default ModalLegalWarning;
